import React, { FunctionComponent } from 'react';
import { FormattedMessage, FormattedDate } from 'react-intl';
import { CouponsQuery_magento2_getCustomerCoupons } from './__generated__/CouponsQuery';
import Table from '../../../components/Table';
import messages from './Coupons.messages';

const CouponItems: FunctionComponent<
  Pick<CouponsQuery_magento2_getCustomerCoupons, 'allCoupons'>
> = ({ allCoupons }) => (
  <Table>
    <thead>
      <tr>
        <th>
          <FormattedMessage {...messages.couponTitle} />
        </th>
        <th>
          <FormattedMessage {...messages.couponCode} />
        </th>
        <th>
          <FormattedMessage {...messages.couponValidFrom} />
        </th>
        <th>
          <FormattedMessage {...messages.couponValidUntil} />
        </th>
      </tr>
    </thead>
    <tbody>
      {allCoupons?.map((coupon) =>
        coupon ? (
          <tr key={coupon.id}>
            <td>
              <span>{coupon.name}</span>
            </td>
            <td>
              <span>{coupon.code}</span>
            </td>
            <td>
              {coupon.fromDate && (
                <FormattedDate
                  year="2-digit"
                  month="2-digit"
                  day="2-digit"
                  value={new Date(coupon.fromDate)}
                />
              )}
            </td>
            <td>
              {coupon.toDate && (
                <FormattedDate
                  year="2-digit"
                  month="2-digit"
                  day="2-digit"
                  value={new Date(coupon.toDate)}
                />
              )}
            </td>
          </tr>
        ) : null
      )}
    </tbody>
  </Table>
);

export default CouponItems;
